import React from "react"
import { Text } from "@/components/Text"

import { themeColors } from "@/styles"

import { InputCharacterCountProps } from "@/components/Input/protocols"

export const CharacterCount = (props: InputCharacterCountProps) => {
	const currentLength = props.value.length
	const isOverLimit = currentLength > props.maxLength

	return (
		<Text.Body
			type="small2"
			color={
				isOverLimit
					? themeColors.getTextErrorColor()
					: themeColors.getDisabledColor()
			}
		>
			{currentLength} / {props.maxLength}
		</Text.Body>
	)
}
